import { create } from 'zustand';

interface NavigationHistoryState {
  hasNavigatedInApp: boolean;
  markNavigated: () => void;
}

const useNavigationHistoryStore = create<NavigationHistoryState>((set) => ({
  hasNavigatedInApp: false,
  markNavigated: () => set({ hasNavigatedInApp: true }),
}));

export default useNavigationHistoryStore;
